import React from 'react';
import Modal from '../../modal/Modal';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { Button } from 'react-bootstrap';
import PegIcon from '../../../images/svg/peg-icon.svg';
import PegIconRebrand from '../../../images/rebrand/svg/peg-icon.svg';
import { useFlags } from 'launchdarkly-react-client-sdk';

var _500PegsMaxModal = function _500PegsMaxModal(props) {
  var _model$PegCount, _model$PrimaryButton, _model$PrimaryButton$, _model$PrimaryLabel, _model$SecondaryLink, _model$SecondaryLink$, _model$SecondaryLabel;

  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      show = props.show,
      hide = props.hide;
  var flags = useFlags();
  var useNewRebrandStyles = flags['releaseRebrandDstr6457'] || false;

  var handleButtonClick = function handleButtonClick(href) {
    return function () {
      hide();

      if (href && href !== '') {
        window.location.href = href;
      }
    };
  };

  return /*#__PURE__*/React.createElement(Modal, {
    className: 'loyalty-modal loyalty-modal--receipt-scan-modal',
    show: show,
    hide: hide,
    hideCloseButton: true,
    backdrop: true,
    noHeader: true
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-receipt-scan-modal'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-receipt-scan-modal__body-container'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-receipt-scan-modal__body-container__peg-counter'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'cb-receipt-scan-modal__peg-counter__text'
  }, (model === null || model === void 0 ? void 0 : (_model$PegCount = model.PegCount) === null || _model$PegCount === void 0 ? void 0 : _model$PegCount.value) || 0), /*#__PURE__*/React.createElement("img", {
    className: 'cb-receipt-scan-modal__peg-counter__icon',
    src: useNewRebrandStyles ? PegIconRebrand : PegIcon,
    alt: 'Peg Icon',
    title: 'Peg Icon'
  })), /*#__PURE__*/React.createElement(Text, {
    tag: 'span',
    className: 'cb-receipt-scan-modal__body-container__header cb-receipt-scan-modal__body-container__header--pegs-modals',
    field: model === null || model === void 0 ? void 0 : model.Headline
  }), /*#__PURE__*/React.createElement(RichText, {
    field: model === null || model === void 0 ? void 0 : model.Copy,
    tag: "span",
    className: 'cb-receipt-scan-modal__body-container__copy'
  }), /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-primary cb-receipt-scan-modal__body-container__button",
    onClick: handleButtonClick((model === null || model === void 0 ? void 0 : (_model$PrimaryButton = model.PrimaryButton) === null || _model$PrimaryButton === void 0 ? void 0 : (_model$PrimaryButton$ = _model$PrimaryButton.value) === null || _model$PrimaryButton$ === void 0 ? void 0 : _model$PrimaryButton$.href) || '')
  }, (model === null || model === void 0 ? void 0 : (_model$PrimaryLabel = model.PrimaryLabel) === null || _model$PrimaryLabel === void 0 ? void 0 : _model$PrimaryLabel.value) || ''), /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-secondary cb-receipt-scan-modal__body-container__button cb-receipt-scan-modal__body-container__button--secondary",
    onClick: handleButtonClick((model === null || model === void 0 ? void 0 : (_model$SecondaryLink = model.SecondaryLink) === null || _model$SecondaryLink === void 0 ? void 0 : (_model$SecondaryLink$ = _model$SecondaryLink.value) === null || _model$SecondaryLink$ === void 0 ? void 0 : _model$SecondaryLink$.href) || '')
  }, (model === null || model === void 0 ? void 0 : (_model$SecondaryLabel = model.SecondaryLabel) === null || _model$SecondaryLabel === void 0 ? void 0 : _model$SecondaryLabel.value) || ''))));
};

export default _500PegsMaxModal;